import { Component } from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';


@Component({
  selector: 'modal-companies',
  templateUrl: 'companies.modal.html',

})
export class CompaniesModal{

  private companies: any = [];
  private filteredCompanies: any = [];
  private search: String = '';

  constructor(public navCtrl: NavController,
              public viewCtrl: ViewController,
              public navParams: NavParams) {

    this.companies = navParams.get('companies');

  }

  ionViewDidLoad() {

    this.filterCompanies();

  }

  filterItems(){

    return this.companies.filter((company) => {
      return company.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    });

  }

  dismiss(company) {
    this.viewCtrl.dismiss(company);
  }

  filterCompanies(){
    this.filteredCompanies = this.filterItems();
  }

  goBack(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/modals/companies/companies.modal.ts